
export const state = {
    permissions: []
}

export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/permissions/state.js